import { useParentId } from "./parent-id-context";


// Custom hook to generate a unique ID
export const useIdBuilder = (id: string): string => {
  const parentId = useParentId();
  return parentId ? `${parentId}.${id}` : id;
};
